const IS_USERNAME_SAVED = 'isUsernameSaved';
const SAVED_USERNAME = 'savedUsername';
const SAVED_DOMAIN = 'savedDomain';
const LANGUAGE = 'lng';

// Returns true for save username, false for not save username
export const getIsUsernameSaved = () => !!localStorage.getItem(IS_USERNAME_SAVED);
// Saves non-empty string to represent isSaveUsername
export const setIsUsernameSaved = (isUsernameSaved) => localStorage.setItem(IS_USERNAME_SAVED, isUsernameSaved ? '1' : '');

export const getSavedUsername = () => localStorage.getItem(SAVED_USERNAME);
export const setSavedUsername = (usernameToSave) => localStorage.setItem(SAVED_USERNAME, usernameToSave);
export const removeSavedUsername = () => localStorage.removeItem(SAVED_USERNAME);

export const getSavedDomain = () => localStorage.getItem(SAVED_DOMAIN);
export const setSavedDomain = (domainToSave) => localStorage.setItem(SAVED_DOMAIN, domainToSave);
export const removeSavedDomain = () => localStorage.removeItem(SAVED_DOMAIN);

export const getSavedLanguage = () => localStorage.getItem(LANGUAGE);
export const setSavedLanguage = (lng) => localStorage.setItem(LANGUAGE, lng);
export const removeSavedLanguage = () => localStorage.removeItem(LANGUAGE);